import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import type { CmsApiSearchLandingPage } from '#/modules/cms/api/types/CmsApiSearchLandingPage';

import { getContentUrlByLocale } from './getContentUrlByLocale';

type Args = {
  content: CmsApiSearchLandingPage;
};

export function getCmsSearchLandingPagePageLayoutHandleProps({
  content,
}: Args): LayoutHandleProps {
  const urlByLocale = getContentUrlByLocale({ content });

  return {
    urlByLocale,
    darkBackground: true,
    defaultSearchType: content.filters.type,
    hideFooterDivider: true,
    showDesktopSearch: true,
    isSearchPage: true,
    isSearchLandingPage: true,
    showSearchRefinements: true,
  };
}
